<template>

  <div id="page-competition-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">All Competitions Loaded</span>
            </div>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
          <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

          <!-- ACTION - DROPDOWN -->
          <vs-dropdown vs-trigger-click class="cursor-pointer">

            <div class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">
              <span class="mr-2 leading-none">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item @click="gridApi.exportDataAsCsv()">
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>CSV</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>
      </div>


      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        class="ag-theme-material w-full my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="competitionsData"
        colResizeDefault="shift"
        :animateRows="true"
        :gridOptions="gridOptions"
      >
      </ag-grid-vue>

    </div>
  </div>

</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Cell Renderer
import CellRendererLink from "./CellRendererLink.vue"
import CellRendererActions from "./CellRendererActions.vue"
import CellRendererBadge from "./CellRendererBadge.vue"

export default {
  components: {
    AgGridVue,
    vSelect,
    CellRendererLink,
    CellRendererActions,
    CellRendererBadge,
  },
  data() {
    return {
      searchQuery: "",

      // AgGrid
      gridApi: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'Name',
          field: 'name',
          filter: true,
          width: 350,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          cellRendererFramework: 'CellRendererLink'
        },
        {
          headerName: 'Active',
          field: 'active',
          filter: true,
          width: 125,
          cellRendererFramework: 'CellRendererBadge'
        },
        {
          headerName: 'Featured',
          field: 'featured',
          filter: true,
          width: 125,
          cellRendererFramework: 'CellRendererBadge'
        },
        {
          headerName: 'Total Tickets',
          field: 'totalTickets',
          filter: true,
          width: 200,
        },
        {
          headerName: 'Tickets Purchased',
          field: 'boughtTickets',
          filter: true,
          width: 200,
        },
        {
          headerName: 'Has Winner?',
          field: 'hasWinner',
          filter: true,
          width: 200,
        },
        {
          headerName: 'Actions',
          field: 'transactions',
          width: 340,
          cellRendererFramework: 'CellRendererActions',
        },
      ],
      gridOptions: {
        onCellValueChanged: () => this.$store.dispatch("competition/fetchCompetitionsPartial")
      },
      components: {
        CellRendererLink,
        CellRendererActions,
      }
    }
  },
  watch: {
    statusFilter(obj) {
      this.setColumnFilter("status", obj.value)
    },
  },
  computed: {
    competitionsData() {
      return this.$store.state.competition.competitions_partial
    },
    paginationPageSize() {
      if(this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if(this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    }
  },
  created() {
    this.$store.dispatch("competition/fetchCompetitionsPartial").catch(err => {
      this.$vs.notify({
        title:'Load Failed',
        text:'Competitions could not be loaded...',
        color:'danger',
        iconPack: 'feather',
        icon:'icon-alert-circle',
        position:'top-right'
      })
      console.error(err)
    });
    if(this.competitionsData !== null) {
      this.$vs.notify({
        title:'Load Success',
        text:'Competitions Loaded Successfully!',
        color:'success',
        iconPack: 'feather',
        icon:'icon-check',
        position:'top-right'
      })
    }
  }
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
